import Swiper from "swiper";
import {SwiperOptions} from "swiper/types";
import {Autoplay, EffectFade, EffectCoverflow, Navigation, Pagination, Thumbs} from "swiper/modules";
import EffectCarousel from "../effect-carousel.esm";

export function swiperSetup(element: HTMLElement, type: string = '', auto: boolean = false): SwiperOptions {
    const configData = element.dataset;
    const slideCount = Number(configData.slideCount || 1);
    const pagination = configData.pagination === 'true';
    const effect = configData.effect || type;
    const multi = configData.multi === 'true';
    const thumbs = configData.thumbs === 'true';
    const loop = configData.loop === 'true';
    const autoplay = configData.autoplay === 'true';

    const parent = element.closest('.swiper-container');

    const config: SwiperOptions = {
        slidesPerView: 1,
        pagination: false,
        loop: loop,
        navigation: {
            addIcons: false,
            nextEl: (parent || element).querySelector<HTMLElement>('.swiper-button-next'),
            prevEl: (parent || element).querySelector<HTMLElement>('.swiper-button-prev'),
        },
        modules: [Navigation],
    };

    if(auto || autoplay){
        config.autoplay = true;
        config.modules?.push(Autoplay);
    }

    if (slideCount > 1) {
        config.breakpoints = {
            767: {
                slidesPerView: slideCount,
                spaceBetween: 20
            },
        };
    }

    if (multi) {
        config.breakpoints = {
            640: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            767: {
                slidesPerView: 4,
                spaceBetween: 20
            },
            1024: {
                slidesPerView: 5,
                spaceBetween: 20
            }
        };
    }

    if (thumbs) {
        const thumbsElement = element.nextElementSibling as HTMLElement;
        if (!thumbsElement) {
            throw new Error('Thumbs element not found');
        }
        const thumbsData = thumbsElement.dataset;
        const swiperThumbs = new Swiper(thumbsElement, {
            spaceBetween: 10,
            slidesPerView: Number(thumbsData.slideCount ?? 4),
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {},
        });
        config.thumbs = {
            swiper: swiperThumbs,
        };
        config.modules?.push(Thumbs);
    }

    if(pagination){
        const slides = element.querySelectorAll<HTMLDivElement>('.swiper-slide');
        config.pagination = {
            enabled: true,
            clickable: true,
            el: '.swiper-pagination',
            renderBullet: (index: number, className: string): string => {
                const title = slides[index].dataset.title;
                return '<span class="' + className + '">' + (title || index + 1) + '</span>';
            },
        };
        config.modules?.push(Pagination);
    }

    if (effect === 'fancy') {
        config.slidesPerView = 2;
        // start on 2nd slide so the carousel looks better
        config.initialSlide = 1;
        config.effect = 'carousel';
        // @ts-ignore
        config.carouselEffect = {
            scaleStep: 0.2,
            sideSlides: 1,
        };
        config.modules?.push(EffectCarousel);
    } else if (effect === 'coverflow') {
        config.slidesPerView = 1;
        config.initialSlide = 1;
        config.centeredSlides = true;
        config.effect = 'coverflow';
        config.coverflowEffect = {
            rotate: 30,
            slideShadows: true,
        };
        config.modules?.push(EffectCoverflow);
    } else if (effect === 'fade') {
        config.effect = 'fade';
        config.fadeEffect = {
            crossFade: true,
        };
        config.modules?.push(EffectFade);
    }

    return config;
}